import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { editComment, deleteComment } from '../../../actions/standupAnswer';
import { icons } from "../../../img/elements/icons";

const CommentItem = ({
  comment: { firstName, lastName, text, user, date, avatar, _id },
  auth,
  deleteComment,
  editComment,
  standupID,
  answerID,
}) => {

  return (
    <div className="comment-body">
      <div className="comment-item">
        <Link to={user ? `/user/${user}` : '#!'} className="user">
          <img
            src={avatar}
            alt="Avatar"
            className="round-img d-block avatar mr-12"
            width="26px"
            height="26px"
          />
        </Link>

        <div className="comment-head">
          <div className="comment-info align-center">
            <p className="comment-user fs-12 bold mb-0">
              <strong>
                {firstName} {lastName}
              </strong>
            </p>

            <div className="icons btn-icons-edit flex align-center">
              <time className="fs-10 grey_new mr-12">
                <Moment format="ddd LLL">{date}</Moment>
              </time>
              {!auth.loading && user === auth.user._id && (
                <button
                  type="button"
                  className="btn-icons btn-delete flex align-center"
                  onClick={e => deleteComment(standupID, answerID, _id)}
                >
                  {icons.circle_close}
                </button>
              )}
            </div>
          </div>

          <p className="fs-12 lh-8">{text}</p>
        </div>
      </div>
    </div>
  );
};

CommentItem.propTypes = {
  auth: PropTypes.object.isRequired,
  answerID: PropTypes.string.isRequired,
  comment: PropTypes.object.isRequired,
  editComment: PropTypes.func.isRequired,
  deleteComment: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { editComment, deleteComment }
)(CommentItem);
